// @ts-nocheck

/* eslint-disable import/no-cycle */
import {
  validateFloatNumberOneDecimal10to100,
  validateFloatNumberTwoDecimal0to100,
  validateFloatNumberTwoDecimal0to1000,
  validateFloatNumberTwoDecimal0to100k,
  validateFloatNumberTwoDecimal1to100,
  validateIntNumber0to2000,
  validateIntNumber0to300k,
  validateIntNumber0to90,
  validateTextMaxLength50,
} from '../../lib/configValidation';
import {
  MEASUREMENT_PROTOCOL_METER_NUMBER_PROPERTIES,
  MEASUREMENT_PROTOCOL_NUMBER_PROPERTIES,
  MEASUREMENT_PROTOCOL_ROOF_NUMBER_PROPERTIES,
} from './measurementProtocol';

export * from './measurementProtocol';

export const LINKS = {
  idLink: 'https://www.leads-middleware.de/login/lead.php?lead=',
} as const;

export const OS = {
  IOS: 'ios',
  ANDROID: 'android',
  WINDOWS: 'windows',
} as const;

export const ENVIRONMENT = {
  DEV: 'dev',
  STAGING1: 'staging1',
  STAGING2: 'staging2',
  STAGING22: 'staging22',
  STAGING23: 'staging23',
  PRODUCTION: 'production',
};

export const DEFAULT_PHONE_NUMBER_COUNTRY_CODE = 'DE';

export const ENTITY = {
  ADDRESS: 'ADDRESS',
  AUDIO_CONTENT: 'AUDIO_CONTENT',
  CALENDAR_ENTRY: 'CALENDAR_ENTRY',
  DEVICE: 'DEVICE',
  EMAIL_ADDRESS: 'EMAIL_ADDRESS',
  FILE: 'FILE',
  IMAGE_ID: 'IMAGE_ID',
  IMAGE: 'IMAGE',
  LEAD_ID: 'LEAD_ID',
  LEAD: 'LEAD',
  MESSAGE: 'MESSAGE',
  MISC_FILE_ID: 'MISC_FILE_ID',
  MISC_FILE: 'MISC_FILE',
  NOTE: 'NOTE',
  PHONE_NUMBER: 'PHONE_NUMBER',
  TEAM: 'TEAM',
  USER_ROLE: 'USER_ROLE',
  USER: 'USER',
  OFFER: 'OFFER',
  // lookup
  AREATYPE: 'AREATYPE',
  LEADPHASE: 'LEADPHASE',
  LEADPHASE_TRANSITION: 'LEADPHASE_TRANSITION',
  LEADSOURCE: 'LEADSOURCE',
  LOADPROFILE: 'LOADPROFILE',
  ROOFTILETYPE: 'ROOFTILETYPE',
  ROOFTYPE: 'ROOFTYPE',
  SALUTATION: 'SALUTATION',
  ZIP_AREA_ROOF_COVERING: 'ZIP_AREA_ROOF_COVERING',
  LEAD_LOST_REASON: 'LEAD_LOST_REASON',
  LEAD_CATEGORY: 'LEAD_CATEGORY',
  // local only
  LOCAL_BINARY_FILE: 'LOCAL_BINARY_FILE',
  LOCAL_CONTACT_RECORD: 'LOCAL_CONTACT_RECORD',
  LOCAL_LEAD_QUERIED: 'LOCAL_LEAD_QUERIED',
  AURORA: 'AURORA',
  AURORA_DESIGN: 'AURORA_DESIGN',
  TASK: 'TASK',
  // MP
  MEASUREMENT_PROTOCOL: 'MEASUREMENT_PROTOCOL',
  MEASUREMENT_PROTOCOL_ROOF: 'MEASUREMENT_PROTOCOL_ROOF',
  MEASUREMENT_PROTOCOL_METER: 'MEASUREMENT_PROTOCOL_METER',
  // MDS
  MASTER_DATA_SERVICE_ADDRESS: 'MASTER_DATA_SERVICE_ADDRESS',
  MASTER_DATA_SERVICE_PROJECT: 'MASTER_DATA_SERVICE_PROJECT',
  MASTER_DATA_SERVICE_CUSTOMER: 'MASTER_DATA_SERVICE_CUSTOMER',
  MASTER_DATA_SERVICE_PERSON: 'MASTER_DATA_SERVICE_PERSON',
  MASTER_DATA_SERVICE_PHONE_NUMBER: 'MASTER_DATA_SERVICE_PHONE_NUMBER',
  MASTER_DATA_SERVICE_EMAIL_ADDRESS: 'MASTER_DATA_SERVICE_EMAIL_ADDRESS',
  MASTER_DATA_SERVICE_BANK_ACCOUNT: 'MASTER_DATA_SERVICE_BANK_ACCOUNT',
  MASTER_DATA_SERVICE_TOP_PERSON_SUB_PERSON:
    'MASTER_DATA_SERVICE_TOP_PERSON_SUB_PERSON',
  MASTER_DATA_SERVICE_PERSON_ADDRESS: 'MASTER_DATA_SERVICE_PERSON_ADDRESS',
  MASTER_DATA_SERVICE_PROJECT_ADDRESS: 'MASTER_DATA_SERVICE_PROJECT_ADDRESS',
  MASTER_DATA_SERVICE_LEGAL_FORM: 'MASTER_DATA_SERVICE_LEGAL_FORM',
  MASTER_DATA_SERVICE_LEGAL_FORM_MAPPING:
    'MASTER_DATA_SERVICE_LEGAL_FORM_MAPPING',
  POWER_OF_ATTORNEY: 'POWER_OF_ATTORNEY',
  NOTIFICATION: 'NOTIFICATION',
  NOTIFICATION_TYPE: 'NOTIFICATION_TYPE',
} as const;

export const ROUTES = {
  LOGINSTACK: {
    LOGIN: 'LOGINSTACK_LOGIN',
    NOT_ALLOWED_USER: 'LOGINSTACK_NOT_ALLOWED_USER',
    UPDATE_NEEDED: 'UPDATE_NEEDED',
  },
  TAB: {
    FOCUS: 'TAB_FOCUS',
    LEADS: 'TAB_LEADS',
    ACTIVITIES: 'TAB_ACTIVITIES',
    MAP: 'TAB_MAP',
  },
  HOMESTACK: {
    ADDRESS_SELECT: 'ADDRESS_SELECT',
    ADDRESS_SELECT_MAP: 'ADDRESS_SELECT_MAP',
    AUDIO_RECORDER: 'HOMESTACK_AUDIO_RECORDER',
    CALENDAR_ENTRY_CREATE: 'HOMESTACK_CALENDAR_ENTRY_CREATE',
    CALENDAR_ENTRY_DETAILS: 'HOMESTACK_CALENDAR_ENTRY_DETAILS',
    CALENDAR_ENTRY_CONFIRMATION_EMAIL: 'CALENDAR_ENTRY_CONFIRMATION_EMAIL',
    CALENDAR_ENTRIES_OVERDUE: 'HOMESTACK_CALENDAR_ENTRIES_OVERDUE',
    CALENDAR: 'HOMESTACK_CALENDAR',
    DESCRIPTION: 'HOMESTACK_DESCRIPTION',
    EMAIL_DETAILS: 'HOMESTACK_EMAIL_DETAILS',
    EMAILS: 'HOMESTACK_EMAILS',
    MULTI_IMAGE_PREVIEW: 'MULTI_IMAGE_PREVIEW',
    LEAD_CREATE: 'HOMESTACK_LEAD_CREATE',
    LEAD_DETAILS_EDIT: 'HOMESTACK_LEAD_DETAILS_EDIT',
    LEAD_DETAILS: 'HOMESTACK_LEAD_DETAILS',
    LEAD_DETAIL_FILE_EDIT: 'LEAD_DETAIL_FILE_EDIT',
    LEAD_SELECT: 'HOMESTACK_LEAD_SELECT',
    LEAD_INFO: 'HOMESTACK_LEAD_INFO_SECTION',
    MENU: 'HOMESTACK_MENU',
    NOTIFICATION_CENTER: 'HOMESTACK_NOTIFICATION_CENTER',
    NOTIFICATION_EDIT: 'HOMESTACK_NOTIFICATION_EDIT',
    NOTE_CREATE: 'HOMESTACK_NOTE_CREATE',
    NOTE_DETAILS: 'HOMESTACK_NOTE_DETAILS',
    SALES_SELECT: 'SALES_SELECT',
    TABS: 'HOMESTACK_TABS',
    MEASUREMENT_PROTOCOL: 'HOMESTACK_MEASUREMENT_PROTOCOL',
    MEASUREMENT_PROTOCOL_STEP: 'MEASUREMENT_PROTOCOL_STEP',
    MEASUREMENT_PROTOCOL_STEP_MARKET_DATA_REGISTER:
      'MEASUREMENT_PROTOCOL_STEP_MARKET_DATA_REGISTER',
    MEASUREMENT_PROTOCOL_STEP_PROPERTY: 'MEASUREMENT_PROTOCOL_STEP_PROPERTY',
    MEASUREMENT_PROTOCOL_STEP_SCAFFOLD: 'MEASUREMENT_PROTOCOL_STEP_SCAFFOLD',
    MEASUREMENT_PROTOCOL_STEP_OBSTACLE: 'MEASUREMENT_PROTOCOL_STEP_OBSTACLE',
    MEASUREMENT_PROTOCOL_STEP_ROOF: 'MEASUREMENT_PROTOCOL_STEP_ROOF',
    MEASUREMENT_PROTOCOL_STEP_ROOF_STRUCTURES:
      'MEASUREMENT_PROTOCOL_STEP_ROOF_STRUCTURES',
    MEASUREMENT_PROTOCOL_STEP_CONCLUSION:
      'MEASUREMENT_PROTOCOL_STEP_CONCLUSION',
    MEASUREMENT_PROTOCOL_STEP_ENERGY_STORAGE_AND_METER:
      'MEASUREMENT_PROTOCOL_STEP_ENERGY_STORAGE_AND_METER',
    MEASUREMENT_PROTOCOL_STEP_CHECKLIST: 'MEASUREMENT_PROTOCOL_STEP_CHECKLIST',
    MEASUREMENT_PROTOCOL_STEP_CONNECTIONS:
      'MEASUREMENT_PROTOCOL_STEP_CONNECTIONS',
    MEASUREMENT_PROTOCOL_VISUAL_DOCUMENTATION:
      'HOMESTACK_MEASUREMENT_PROTOCOL_VISUAL_DOCUMENTATION',
    MEASUREMENT_PROTOCOL_ROOF_NESTED:
      'HOMESTACK_MEASUREMENT_PROTOCOL_ROOF_NESTED',
    MEASUREMENT_PROTOCOL_METER_NESTED:
      'HOMESTACK_MEASUREMENT_PROTOCOL_METER_NESTED',
    MEASUREMENT_PROTOCOL_LARGE_CONSUMER_NESTED:
      'MEASUREMENT_PROTOCOL_LARGE_CONSUMER_NESTED',
    MEASUREMENT_PROTOCOL_INVERTER_NESTED:
      'MEASUREMENT_PROTOCOL_INVERTER_NESTED',
    PROPERTY_VISUAL_REPRESENTATION: 'PROPERTY_VISUAL_REPRESENTATION',
    PROPERTY_VISUAL_REPRESENTATION_ON_IMAGE:
      'PROPERTY_VISUAL_REPRESENTATION_ON_IMAGE',
    PROPERTY_VISUAL_REPRESENTATION_SKETCH:
      'PROPERTY_VISUAL_REPRESENTATION_SKETCH',
    SIGNATURE: 'SIGNATURE',
    TASK_CREATE: 'HOMESTACK_TASK_CREATE',
    TASK_DETAILS: 'HOMESTACK_TASK_DETAILS',
    MESSAGE_DETAILS: 'HOMESTACK_MESSAGE_DETAILS',
    MASTER_DATA_SERVICE_CREATE: 'HOMESTACK_MASTER_DATA_SERVICE_CREATE',
    MASTER_DATA_SERVICE_CUSTOMER: 'HOMESTACK_MASTER_DATA_SERVICE_CUSTOMER',
    MASTER_DATA_SERVICE_SUB_PERSON: 'HOMESTACK_MASTER_DATA_SERVICE_SUB_PERSON',
    MASTER_DATA_SERVICE_FORMER_ADDRESS:
      'HOMESTACK_MASTER_DATA_SERVICE_FORMER_ADDRESS',
    MASTER_DATA_SERVICE_POWER_OF_ATTORNEY:
      'HOMESTACK_MASTER_DATA_SERVICE_POWER_OF_ATTORNEY',
    MASTER_DATA_SERVICE_POWER_OF_ATTORNEY_MASTR:
      'HOMESTACK_MASTER_DATA_SERVICE_POWER_OF_ATTORNEY_MASTR',
    MASTER_DATA_SERVICE_POWER_OF_ATTORNEY_NETWORK_REGISTRATION:
      'MASTER_DATA_SERVICE_POWER_OF_ATTORNEY_NETWORK_REGISTRATION',
    VIDEO_MESSAGE_CREATE: 'HOMESTACK_VIDEO_MESSAGE_CREATE',
    OFFER_EDIT_SCREEN: 'HOMESTACK_OFFER_EDIT_SCREEN',
    OFFER_NESTED_ENTITY: 'HOMESTACK_OFFER_NESTED_ENTITY',
    OFFER_LIST: 'HOMESTACK_OFFER_LIST',
    OFFER_SELECT: 'HOMESTACK_OFFER_SELECT',
    OFFER_FINAL_SELECT: 'HOMESTACK_OFFER_FINAL_SELECT',
    OFFER_CONFIRMATION_EMAIL: 'HOMESTACK_OFFER_CONFIRMATION_EMAIL',
    OFFER_OPTIONS: 'HOMESTACK_OFFER_OPTIONS',
    OFFER_PRICE_EDIT: 'HOMESTACK_OFFER_PRICE_EDIT',
  },
  ACTIVITIES: {
    ACTIVITIES: 'ACTIVITIES_ACTIVITIES',
    CALENDAR: 'ACTIVITIES_CALENDAR',
    MAILBOX: 'ACTIVITIES_MAILBOX',
  },
  LEAD: {
    INFO: 'LEAD_INFO',
    TIMELINE: 'LEAD_TIMELINE',
    FILES: 'LEAD_FILES',
  },
  OFFER: {
    CREATION: 'CREATION',
    OVERVIEW: 'OVERVIEW',
  },
} as const;

export const DETAILS_SCREENS_ROUTES_TO_ENTITIES_MAP = {
  [ROUTES.HOMESTACK.CALENDAR_ENTRY_DETAILS]: ENTITY.CALENDAR_ENTRY,
  [ROUTES.HOMESTACK.NOTE_DETAILS]: ENTITY.NOTE,
  [ROUTES.HOMESTACK.LEAD_DETAILS]: ENTITY.LEAD,
} as const;

export const BACKEND_API = {
  LEADS_MIDDLEWARE: 'LEADS_MIDDLEWARE',
  SALES_BACKEND: 'SALES_BACKEND',
} as const;

export const EVENT_SOURCE = {
  APP: 'APP',
  USER: 'USER',
} as const;

export const LOG_LEVEL = {
  debug: 'debug',
  info: 'info',
  warn: 'warn',
  error: 'error',
} as const;

export const MEDIA_TYPE = {
  PHOTO: 'photo',
  VIDEO: 'video',
  MIXED: 'mixed',
} as const;

export const IMAGE_PROCESSING = {
  QUALITY: 0.5,
  HEIC_TO_JPG_CONVERSION_QUALITY: 0.5,
} as const;

export const LOG_KEY = {
  error_handling: 'ERROR_HANDLING',
  api: 'API',
  app: { saga: 'APP_SAGA', navigate: 'APP_NAVIGATE', linking: 'APP_LINKING' },
  versionCheck: 'VERSION_CHECK',
  audio: { record: 'AUDIO_RECORD', speechToText: 'SPEECH_TO_TEXT' },
  binary: {
    upload: 'UPLOAD',
    video_compression: 'VIDEO_COMPRESSION',
  },
  backend: {
    binaryUpload: 'BACKEND_BINARY_UPLOAD',
    configuration: 'BACKEND_CONFIGURATION',
    sync: 'BACKEND_SYNC',
    syncBinary: 'BACKEND_SYNC_BINARY',
    syncDelete: 'BACKEND_SYNC_DELETE',
    syncFormChange: 'BACKEND_SYNC_FORM_CHANGE',
    syncHandlePushedChange: 'BACKEND_SYNC_HANDLE_PUSHED_CHANGE',
    syncPushChange: 'BACKEND_SYNC_PUSH_CHANGE',
    onDemand: 'BACKEND_ON_DEMAND',
  },
  form: {
    errorScroll: 'FORM_ERROR_SCROLL',
  },
  tracking: {
    analytics: 'ANALYTICS',
    crashlytics: 'CRASHLYTICS',
    performanceMonitoring: 'PERFORMANCE_MONITORING',
  },
  calculation: {
    sectionFormatCalendarEntries: 'SECTION_FORMAT_CALCULATION_ENTRIES',
  },
  calendar: {
    calculate: 'CALENDAR_CALCULATE',
    reducer: 'CALENDAR_REDUCER',
    selector: 'CALENDAR_SELECTOR',
  },
  db: {
    changedValuesFilter: 'DB_CHANGED_VALUES_FILTER',
    changeNotify: 'DB_CHANGE_NOTIFY',
    default: 'DB',
    deleteForEntity: 'DB_DELETE_FOR_ENTITY',
    formSaga: 'DB_FORM_SAGA',
    persist: 'DB_PERSIST',
    query: 'DB_QUERY',
    queryBuilder: 'DB_QUERY_BUILDER',
    querySaga: 'DB_QUERY_SAGA',
    selectIsStepDone: 'SELECT_IS_STEP_DONE',
    transactions: 'DB_TRANSACTIONS',
  },
  downloadService: 'DOWNLOAD_SERVICE',
  fileStatus: 'FILE_STATUS',
  jsApi: 'JS_API',
  map: {
    snapshot: 'MAP_SNAPSHOT',
  },
  navigation: 'NAVIGATION',
  storage: 'STORAGE',
  ui: {
    display: 'UI_DISPLAY',
    typeError: 'UI_TYPE_ERROR',
  },
  uploadService: 'UPLOAD_SERVICE',
  measurementProtocol: {
    form: {
      stepMissing: 'MEASUREMENT_PROTOCOL_FORM_STEP_MISSING',
    },
  },
  location: 'LOCATION',
  notifications: 'NOTIFICATIONS',
} as const;

export const NAVIGATE_TYPE = {
  TO: 'to',
  PUSH: 'push',
  POP: 'pop',
  REPLACE: 'replace',
} as const;

export const LEAD_STATE = {
  OPEN: 'OPEN',
  LOST: 'LOST',
  WON: 'WON',
} as const;

export const URLS = {
  ABOUT: 'https://www.ekd-solar.de/impressum/',
  PRIVACY_PROTECTION: 'https://www.ekd-solar.de/datenschutzerklaerung/',
  MIDDLEWARE: 'https://leads-middleware.de',
} as const;

export const THEME_OPTION = {
  LIGHT: 'light',
  DARK: 'dark',
  DEVICE: 'device',
} as const;

export const MESSAGE_TYPE = {
  TO_PLANNER: 'TO_PLANNER',
  FROM_PLANNER: 'FROM_PLANNER',
} as const;

export const NOTE_TYPE = {
  NOTE: {
    label: 'note.type.note',
    value: 'NOTE',
  },
  MINUTE_CALL: {
    label: 'note.type.minuteCall',
    value: 'MINUTE_CALL',
  },
  MINUTE_MEETING: {
    label: 'note.type.minuteMeeting',
    value: 'MINUTE_MEETING',
  },
} as const;

export const NOTE_CONTEXT_TYPE = {
  USER_CREATE: 'USER_CREATE',
  CALENDAR_DONE: 'CALENDAR_DONE',
  CALENDAR_REOPEN: 'CALENDAR_REOPEN',
} as const;

export const SATELLITE_IMAGE_EDIT_MODE = {
  DRAWING: 'DRAWING',
  WRITING: 'WRITING',
} as const;

export const LEAD_FILTER_ENTRY_TYPE = {
  ALL: {
    label: 'filter.allEntries',
    value: 'ALL',
  },
  MEASUREMENT_MEETING: {
    label: 'filter.onlyMeasurementMeeting',
    value: 'MEASUREMENT_MEETING',
  },
  OFFER_MEETING: {
    label: 'calendarEntry.type.offerMeeting',
    value: 'OFFER_MEETING',
  },
  FOLLOW_UP_MEETING: {
    label: 'filter.onlyFollowUpMeeting',
    value: 'FOLLOW_UP_MEETING',
  },
  CUSTOMER_MEETING: {
    label: 'filter.onlyCustomerMeeting',
    value: 'CUSTOMER_MEETING',
  },
  CALL: {
    label: 'filter.onlyCalls',
    value: 'CALL',
  },
  EMAIL: {
    label: 'filter.onlyEmails',
    value: 'EMAIL',
  },
  TASK: {
    label: 'filter.onlyTasks',
    value: 'TASK',
  },
  MEETING: {
    label: 'filter.onlyMeeting',
    value: 'MEETING',
  },
} as const;

export const LEAD_TIMELINE_DONE_FILTER_ENTRY_TYPE = {
  ALL: {
    label: 'timelineDoneFilter.allEntries',
    value: 'ALL',
  },
  CALENDAR_ENTRY: {
    label: 'timelineDoneFilter.onlyCalendarEntries',
    value: 'CALENDAR_ENTRY',
  },
  NOTE: {
    label: 'timelineDoneFilter.onlyNotes',
    value: 'NOTE',
  },
  MESSAGE: {
    label: 'timelineDoneFilter.onlyMessages',
    value: 'MESSAGE',
  },
} as const;

export const FILTER_TYPES = {
  sort: 'SORT',
  owner: 'OWNER',
  state: 'STATE',
  time: 'TIME',
  type: 'TYPE',
} as const;

export const FILE_TYPE_FILTER = {
  ALL: { label: 'filter.allEntries', value: 'ALL' },
  MISCFILE: { label: 'filter.onlyFiles', value: 'MISCFILE' },
  IMAGE: { label: 'filter.onlyImages', value: 'IMAGE' },
} as const;

export const DOCUMENT_DEFINITION = {
  NO_CATEGORY: 'sales-uncategorized',
  ROOF_BUILDING: 'roof-building',
  ENERGY_METER: 'meter-cabinet-or-meter',
  LOCATION_STORAGE: 'storage-location',
  LOCATION_WALLBOX: 'wallbox-location',
  HOUSE_CONNECTION_BOX: 'house-connection-box',
  MEASUREMENT_PROTOCOL_ANNOTATED_SATELLITE_IMAGE: 'annotated-satellite-image',
  MEASUREMENT_PROTOCOL_CUSTOM_IMAGE: 'custom-image-without-markers',
  MEASUREMENT_PROTOCOL_ROOF_AREA: 'roof-area',
  MEASUREMENT_PROTOCOL_ANNOTATED_CUSTOM_IMAGE: 'annotated-custom-image',
  MEASUREMENT_PROTOCOL_STORAGE_FACILITY_AT_GROUND_LEVEL: 'storage-facility',
  MEASUREMENT_PROTOCOL_STORAGE_FACILITY: 'storage-facility',
  MEASUREMENT_PROTOCOL_OBSTACLE: 'obstacle',
  MEASUREMENT_PROTOCOL_SCAFFOLD_OBSTACLE: 'scaffold-public-obstacle',
  MEASUREMENT_PROTOCOL_SCAFFOLD_PUBLIC_OBSTACLE: 'scaffold-public-obstacle',
  MEASUREMENT_PROTOCOL_SCAFFOLD_INSTALLATION_AREA: 'scaffold-location',
  MEASUREMENT_PROTOCOL_ENERGY_STORAGE_METER: 'electricity-meter',
  MEASUREMENT_PROTOCOL_METER_LOCATION: 'electricity-meter-location',
  MEASUREMENT_PROTOCOL_STORAGE_LOCATION: 'storage-location',
  MEASUREMENT_PROTOCOL_ENERGY_METER_CABINET: 'electricity-meter-cabinet',
  MEASUREMENT_PROTOCOL_SPACE_FOR_ADDITIONAL_ENERGY_METER_CABINET:
    'space-for-additional-electricity-meter-cabinet',
  MEASUREMENT_PROTOCOL_EQUIPOTENTIAL_BONDING_RAIL: 'equipotential-bonding-rail',
  MEASUREMENT_PROTOCOL_GROUNDING: 'grounding',
  MEASUREMENT_PROTOCOL_VALVE: 'valve',
  MEASUREMENT_PROTOCOL_HEATING_CIRCUIT_DISTRIBUTOR:
    'heating-circuit-distributor',
  MEASUREMENT_PROTOCOL_ROOM_CONTROLLER: 'room-controller',
  MEASUREMENT_PROTOCOL_FLAT_ROOF: 'flat-roof',
  MEASUREMENT_PROTOCOL_HEAT_PUMP: 'heat-pump',
  MEASUREMENT_PROTOCOL_ROOF_STRUCTURES: 'roof-structure',
  MEASUREMENT_PROTOCOL_DC_CABLE_ROUTING_ALONG_OUTSIDE_FACADE:
    'dc-cable-routing-along-outside-facade',
  MEASUREMENT_PROTOCOL_DC_CABLE_ROUTING: 'dc-cable-routing',
  MEASUREMENT_PROTOCOL_DC_CABLE_ROUTING_ALONG_ROOF_CLADDING:
    'dc-cable-routing-along-roof-cladding',
  MEASUREMENT_PROTOCOL_HOUSE_CONNECTION_BOX: 'house-connection-box',
  MEASUREMENT_PROTOCOL_OVERHEAD_LINE: 'overhead-line',
  MEASUREMENT_PROTOCOL_OVERHEAD_LINE_UNDERGROUND_CABLE:
    'overhead-line-underground-cable',
  MEASUREMENT_PROTOCOL_FLASH_UNIT: 'flash-unit',
  MEASUREMENT_PROTOCOL_BRICK: 'roof-covering-brick',
  MEASUREMENT_PROTOCOL_ROOF_RENOVATION: 'roof-renovation',
  MEASUREMENT_PROTOCOL_ROOF_TRUSS: 'roof-truss',
  MEASUREMENT_PROTOCOL_ROOF_TRUSS_OTHERS: 'roof-truss-others',
  MEASUREMENT_PROTOCOL_LARGE_CONSUMER: 'large-consumer',
  MEASUREMENT_PROTOCOL_SIGNATURE: 'sales-customer-signature',
  MEASUREMENT_PROTOCOL_SALES_SIGNATURE: 'sales-signature',
  MEASUREMENT_PROTOCOL_MONUMENT_PROTECTION: 'monument-protection',
  MEASUREMENT_PROTOCOL_STORAGE_METER_CABLE_ROUTE: 'storage-meter-cable-route',
  MEASUREMENT_PROTOCOL_NETWORK_CONNECTIVITY: 'network-connectivity',
  MEASUREMENT_PROTOCOL_POWER_CONNECTION_TYPE: 'power-connection-type',
  MEASUREMENT_PROTOCOL_EXISTING_GENERATING_PLANT: 'existing-generating-plant',
  MASTR_SIGNATURE: 'mastr-signature',
  VIDEO_MESSAGE: 'sales-lead-video',
  PLANNING_TASK: 'task-document',
  SALES_PODCAST: 'sales-podcast',
  PROJECT_DOCUMENT: 'project-document',
  ENERGY_BILL: 'energy-bill',
} as const;

export const MISCFILE_CATEGORIES = {
  NO_CATEGORY: 'NO_CATEGORY',
  ROOF_BUILDING: 'ROOF_BUILDING',
  ENERGY_METER: 'ENERGY_METER',
  LOCATION_STORAGE: 'LOCATION_STORAGE',
  LOCATION_WALLBOX: 'LOCATION_WALLBOX',
  HOUSE_CONNECTION_BOX: 'HOUSE_CONNECTION_BOX',
  ELECTRICITY_BILL: 'ELECTRICITY_BILL',
  MEASUREMENT_PROTOCOL_OBSTACLE: 'MEASUREMENT_PROTOCOL_OBSTACLE',
  MEASUREMENT_PROTOCOL_SCAFFOLD_OBSTACLE:
    'MEASUREMENT_PROTOCOL_SCAFFOLD_OBSTACLE',
  MEASUREMENT_PROTOCOL_SCAFFOLD_PUBLIC_OBSTACLE:
    'MEASUREMENT_PROTOCOL_SCAFFOLD_PUBLIC_OBSTACLE',
  MEASUREMENT_PROTOCOL_ENERGY_STORAGE_METER:
    'MEASUREMENT_PROTOCOL_ENERGY_STORAGE_METER',
  MEASUREMENT_PROTOCOL_ENERGY_METER_CABINET:
    'MEASUREMENT_PROTOCOL_ENERGY_METER_CABINET',
  MEASUREMENT_PROTOCOL_SPACE_FOR_ADDITIONAL_ENERGY_METER_CABINET:
    'MEASUREMENT_PROTOCOL_SPACE_FOR_ADDITIONAL_ENERGY_METER_CABINET',
  MEASUREMENT_PROTOCOL_EQUIPOTENTIAL_BONDING_RAIL:
    'MEASUREMENT_PROTOCOL_EQUIPOTENTIAL_BONDING_RAIL',
  MEASUREMENT_PROTOCOL_VALVE: 'MEASUREMENT_PROTOCOL_VALVE',
  MEASUREMENT_PROTOCOL_HEATING_CIRCUIT_DISTRIBUTOR:
    'MEASUREMENT_PROTOCOL_HEATING_CIRCUIT_DISTRIBUTOR',
  MEASUREMENT_PROTOCOL_ROOM_CONTROLLER: 'MEASUREMENT_PROTOCOL_ROOM_CONTROLLER',
  MEASUREMENT_PROTOCOL_FLAT_ROOF: 'MEASUREMENT_PROTOCOL_FLAT_ROOF',
  MEASUREMENT_PROTOCOL_ROOF_STRUCTURES: 'MEASUREMENT_PROTOCOL_ROOF_STRUCTURES',
  MEASUREMENT_PROTOCOL_DC_CABLE_ROUTING_ALONG_OUTSIDE_FACADE:
    'MEASUREMENT_PROTOCOL_DC_CABLE_ROUTING_ALONG_OUTSIDE_FACADE',
  MEASUREMENT_PROTOCOL_DC_CABLE_ROUTING_ALONG_ROOF_CLADDING:
    'MEASUREMENT_PROTOCOL_DC_CABLE_ROUTING_ALONG_ROOF_CLADDING',
  MEASUREMENT_PROTOCOL_HOUSE_CONNECTION_BOX:
    'MEASUREMENT_PROTOCOL_HOUSE_CONNECTION_BOX',
  MEASUREMENT_PROTOCOL_OVERHEAD_LINE: 'MEASUREMENT_PROTOCOL_OVERHEAD_LINE',
  MEASUREMENT_PROTOCOL_OVERHEAD_LINE_UNDERGROUND_CABLE:
    'MEASUREMENT_PROTOCOL_OVERHEAD_LINE_UNDERGROUND_CABLE',
  MEASUREMENT_PROTOCOL_STORAGE_FACILITY_AT_GROUND_LEVEL:
    'MEASUREMENT_PROTOCOL_STORAGE_FACILITY_AT_GROUND_LEVEL',
  MEASUREMENT_PROTOCOL_BRICK: 'MEASUREMENT_PROTOCOL_BRICK',
  MEASUREMENT_PROTOCOL_ROOF_AREA: 'MEASUREMENT_PROTOCOL_ROOF_AREA',
  MEASUREMENT_PROTOCOL_METER_LOCATION: 'MEASUREMENT_PROTOCOL_METER_LOCATION',
  MEASUREMENT_PROTOCOL_STORAGE_LOCATION:
    'MEASUREMENT_PROTOCOL_STORAGE_LOCATION',
  MEASUREMENT_PROTOCOL_GROUNDING: 'MEASUREMENT_PROTOCOL_GROUNDING',
  MEASUREMENT_PROTOCOL_HEAT_PUMP: 'MEASUREMENT_PROTOCOL_HEAT_PUMP',
  MEASUREMENT_PROTOCOL_DC_CABLE_ROUTING:
    'MEASUREMENT_PROTOCOL_DC_CABLE_ROUTING',
  MEASUREMENT_PROTOCOL_FLASH_UNIT: 'MEASUREMENT_PROTOCOL_FLASH_UNIT',
  MEASUREMENT_PROTOCOL_ROOF_RENOVATION: 'MEASUREMENT_PROTOCOL_ROOF_RENOVATION',
  MEASUREMENT_PROTOCOL_ROOF_TRUSS_OTHERS:
    'MEASUREMENT_PROTOCOL_ROOF_TRUSS_OTHERS',
  MEASUREMENT_PROTOCOL_LARGE_CONSUMER: 'MEASUREMENT_PROTOCOL_LARGE_CONSUMER',
  MEASUREMENT_PROTOCOL_STORAGE_FACILITY:
    'MEASUREMENT_PROTOCOL_STORAGE_FACILITY',
  MEASUREMENT_PROTOCOL_MONUMENT_PROTECTION:
    'MEASUREMENT_PROTOCOL_MONUMENT_PROTECTION',
  MEASUREMENT_PROTOCOL_ROOF_TRUSS: 'MEASUREMENT_PROTOCOL_ROOF_TRUSS',
  MEASUREMENT_PROTOCOL_STORAGE_METER_CABLE_ROUTE:
    'MEASUREMENT_PROTOCOL_STORAGE_METER_CABLE_ROUTE',
  MEASUREMENT_PROTOCOL_POWER_CONNECTION_TYPE:
    'MEASUREMENT_PROTOCOL_POWER_CONNECTION_TYPE',
  MEASUREMENT_PROTOCOL_EXISTING_GENERATING_PLANT:
    'MEASUREMENT_PROTOCOL_EXISTING_GENERATING_PLANT',
  VIDEO_MESSAGE: 'VIDEO_MESSAGE',
  PLANNING_TASK: 'PLANNING_TASK',
  MEASUREMENT_PROTOCOL_NETWORK_CONNECTIVITY:
    'MEASUREMENT_PROTOCOL_NETWORK_CONNECTIVITY',
} as const;

export const IMAGE_CATEGORIES_LABELS = {
  NO_CATEGORY: 'imageCategories.noCategory',
  ROOF_BUILDING: 'imageCategories.roofBuilding',
  ENERGY_METER: 'imageCategories.energyMeter',
  LOCATION_STORAGE: 'imageCategories.locationStorage',
  LOCATION_WALLBOX: 'imageCategories.locationWallbox',
  HOUSE_CONNECTION_BOX: 'imageCategories.houseConnectionBox',
  MEASUREMENT_PROTOCOL_OBSTACLE: 'imageCategories.obstacle',
  MEASUREMENT_PROTOCOL_SCAFFOLD_OBSTACLE: 'imageCategories.scaffoldObstacle',
  MEASUREMENT_PROTOCOL_SCAFFOLD_PUBLIC_OBSTACLE:
    'imageCategories.scaffoldPublicObstacle',
  MEASUREMENT_PROTOCOL_ENERGY_STORAGE_METER: 'imageCategories.storageMeter',
  MEASUREMENT_PROTOCOL_ENERGY_METER_CABINET: 'imageCategories.meterCabinet',
  MEASUREMENT_PROTOCOL_EQUIPOTENTIAL_BONDING_RAIL:
    'imageCategories.bondingRail',
  MEASUREMENT_PROTOCOL_SPACE_FOR_ADDITIONAL_ENERGY_METER_CABINET:
    'imageCategories.spaceForAdditionalEnergyMeterCabinet',
  MEASUREMENT_PROTOCOL_VALVE: 'imageCategories.valve',
  MEASUREMENT_PROTOCOL_HEATING_CIRCUIT_DISTRIBUTOR:
    'imageCategories.heatingCircuitDistributor',
  MEASUREMENT_PROTOCOL_ROOM_CONTROLLER: 'imageCategories.roomController',
  MEASUREMENT_PROTOCOL_ROOF_AREA: 'imageCategories.roofArea',
  MEASUREMENT_PROTOCOL_FLAT_ROOF: 'imageCategories.flatRoof',
  MEASUREMENT_PROTOCOL_ROOF_STRUCTURES: 'imageCategories.roofStructures',
  MEASUREMENT_PROTOCOL_DC_CABLE_ROUTING_ALONG_OUTSIDE_FACADE:
    'imageCategories.dcCableRoutingAlongOutsideFacade',
  MEASUREMENT_PROTOCOL_DC_CABLE_ROUTING_ALONG_ROOF_CLADDING:
    'imageCategories.dcCableRoutingAlongRoofCladding',
  MEASUREMENT_PROTOCOL_HOUSE_CONNECTION_BOX:
    'imageCategories.houseConnectionBox',
  MEASUREMENT_PROTOCOL_OVERHEAD_LINE: 'imageCategories.overheadLine',
  MEASUREMENT_PROTOCOL_OVERHEAD_LINE_UNDERGROUND_CABLE:
    'imageCategories.overheadLineUndergroundCable',
  MEASUREMENT_PROTOCOL_STORAGE_FACILITY_AT_GROUND_LEVEL:
    'imageCategories.storageFacilityAtGroundLevel',
  VIDEO_MESSAGE: 'imageCategories.videoMessage',
  PLANNING_TASK: 'imageCategories.planningTask',
  FLASH_UNIT: 'imageCategories.flashUnit',
  MEASUREMENT_PROTOCOL_SCAFFOLD_INSTALLATION_AREA:
    'imageCategories.scaffoldInstallationArea',
  MEASUREMENT_PROTOCOL_METER_LOCATION: 'imageCategories.meterLocation',
  MEASUREMENT_PROTOCOL_STORAGE_LOCATION: 'imageCategories.storageLocation',
  MEASUREMENT_PROTOCOL_GROUNDING: 'imageCategories.grounding',
  MEASUREMENT_PROTOCOL_HEAT_PUMP: 'imageCategories.heatPump',
  MEASUREMENT_PROTOCOL_DC_CABLE_ROUTING: 'imageCategories.dcCableRouting',
  MEASUREMENT_PROTOCOL_FLASH_UNIT: 'imageCategories.flashUnit',
  MEASUREMENT_PROTOCOL_BRICK: 'imageCategories.brick',
  MEASUREMENT_PROTOCOL_ROOF_RENOVATION: 'imageCategories.roofRenovation',
  MEASUREMENT_PROTOCOL_ROOF_TRUSS_OTHERS: 'imageCategories.roofTrussOthers',
  MEASUREMENT_PROTOCOL_LARGE_CONSUMER: 'imageCategories.largeConsumer',
  MEASUREMENT_PROTOCOL_STORAGE_FACILITY: 'imageCategories.storageFacility',
  MEASUREMENT_PROTOCOL_MONUMENT_PROTECTION:
    'imageCategories.monumentProtection',
  MEASUREMENT_PROTOCOL_NETWORK_CONNECTIVITY:
    'imageCategories.networkConnectivity',
  MEASUREMENT_PROTOCOL_ROOF_TRUSS: 'imageCategories.roofTruss',
  MEASUREMENT_PROTOCOL_STORAGE_METER_CABLE_ROUTE:
    'imageCategories.storageMeterCableRoute',
  MEASUREMENT_PROTOCOL_POWER_CONNECTION_TYPE:
    'imageCategories.powerConnectionType',
  MEASUREMENT_PROTOCOL_EXISTING_GENERATING_PLANT:
    'imageCategories.existingGeneratingPlant',
} as const;

export const IMAGE_CATEGORIES_FILTER = {
  NO_CATEGORY: {
    value: DOCUMENT_DEFINITION.NO_CATEGORY,
    label: IMAGE_CATEGORIES_LABELS.NO_CATEGORY,
  },
  ROOF_BUILDING: {
    value: DOCUMENT_DEFINITION.ROOF_BUILDING,
    label: IMAGE_CATEGORIES_LABELS.ROOF_BUILDING,
  },
  ENERGY_METER: {
    value: DOCUMENT_DEFINITION.ENERGY_METER,
    label: IMAGE_CATEGORIES_LABELS.ENERGY_METER,
  },
  LOCATION_STORAGE: {
    value: DOCUMENT_DEFINITION.LOCATION_STORAGE,
    label: IMAGE_CATEGORIES_LABELS.LOCATION_STORAGE,
  },
  LOCATION_WALLBOX: {
    value: DOCUMENT_DEFINITION.LOCATION_WALLBOX,
    label: IMAGE_CATEGORIES_LABELS.LOCATION_WALLBOX,
  },
  HOUSE_CONNECTION_BOX: {
    value: DOCUMENT_DEFINITION.HOUSE_CONNECTION_BOX,
    label: IMAGE_CATEGORIES_LABELS.HOUSE_CONNECTION_BOX,
  },
} as const;

export const LEAD_TYPE_I18N = {
  BUSINESS: 'lead.business',
  PRIVATE: 'lead.private',
} as const;

export const PHONE_CONNECTION_TYPE = {
  MOBILE: 'MOBILE',
  LANDLINE: 'LANDLINE',
} as const;

// TODO: also integrate property_goal, property_recent_distribution_board, property_roof_align, property_roof_pitch_degree
export const HOUSE_PROPERTIES = {
  BASIC_FEE_HEAT: 'BASIC_FEE_HEAT',
  BASIC_FEE_ELECTRICITY: 'BASIC_FEE_ELECTRICITY',
  DESIRED_BS_CAPACITY: 'DESIRED_BS_CAPACITY',
  DESIRED_PV_OUTPUT: 'DESIRED_PV_OUTPUT',
  DISTANCE_GROUND_GUTTER: 'DISTANCE_GROUND_GUTTER',
  DISTANCE_GUTTER_RIDGE: 'DISTANCE_GUTTER_RIDGE',
  HEAT_ELECTRICITY: 'HEAT_ELECTRICITY',
  HOUSE_ELECTRICITY: 'HOUSE_ELECTRICITY',
  HOUSE_ELECTRICITY_METER_NUMBER: 'HOUSE_ELECTRICITY_METER_NUMBER',
  HEAT_ELECTRICITY_METER_NUMBER: 'HEAT_ELECTRICITY_METER_NUMBER',
  LOADPROFILE: 'LOADPROFILE',
  PRICE_HEAT: 'PRICE_HEAT',
  PRICE_LIGHT: 'PRICE_LIGHT',
  ROOF_ALIGN: 'ROOF_ALIGN',
  ROOF_PITCH_DEGREE: 'ROOF_PITCH_DEGREE',
  ROOF_TYPE: 'ROOF_TYPE',
  ROOF_TILE_COVERAGE: 'ROOF_TILE_COVERAGE',
  ROOF_TILE_DIMENSIONS: 'ROOF_TILE_DIMENSIONS',
  ROOF_TILE_TYPE: 'ROOF_TILE_TYPE',
  SOLAR_EDGE_WIDTH_M: 'SOLAR_EDGE_WIDTH_M',
  SMART_HOME: 'SMART_HOME',
} as const;

export const SMART_HOME_VALUES = {
  NOT_INTERESTED: { value: 'NOT_INTERESTED', label: 'Kein Interesse' },
  HEATER_ONLY: { value: 'HEATER_ONLY', label: 'Nur Heizkörper' },
  UNDERFLOOR_HEATING_ONLY: {
    value: 'UNDERFLOOR_HEATING_ONLY',
    label: 'Nur Fußbodenheizung',
  },
  HEATER_AND_UNDERFLOOR_HEATING: {
    value: 'HEATER_AND_UNDERFLOOR_HEATING',
    label: 'Heizkörper und Fußbodenheizung',
  },
} as const;

export const HOUSE_PROPERTIES_MAPPING = {
  [HOUSE_PROPERTIES.ROOF_TYPE]: {
    edit: 'rooftype_id',
    content: 'rooftype_name',
    isTextField: true,
    label: 'lead.roofType', // Dachform
    keyboardType: 'default',
    testId: 'leadRoofType',
  },
  [HOUSE_PROPERTIES.ROOF_ALIGN]: {
    content: 'roof_align',
    label: 'lead.roofAlign', // Dachausrichtung
    isTextField: true,
    validation: validateTextMaxLength50,
    keyboardType: 'default',
    testId: 'leadRoofAlign',
  },
  [HOUSE_PROPERTIES.ROOF_PITCH_DEGREE]: {
    content: 'roof_pitch_degree',
    label: 'lead.roofPitchDegree', // Dachneigung (in Grad)
    validation: validateIntNumber0to90,
    keyboardType: 'numeric',
    testId: 'leadRoofPitchDegree',
  },
  [HOUSE_PROPERTIES.DISTANCE_GUTTER_RIDGE]: {
    content: 'distance_gutter_ridge_m',
    label: 'lead.distanceGutterRidge', // Distanz Traufe-First (in m)
    validation: validateFloatNumberTwoDecimal0to100,
    keyboardType: 'numeric',
    testId: 'leadDistanceGutterRidge',
  },
  [HOUSE_PROPERTIES.DISTANCE_GROUND_GUTTER]: {
    content: 'distance_ground_gutter_m',
    label: 'lead.distanceGroundGutter', // Distanz Boden-Dachrinne (in m)
    validation: validateFloatNumberTwoDecimal0to100,
    keyboardType: 'numeric',
    testId: 'leadDistanceGroundGutter',
  },
  [HOUSE_PROPERTIES.SOLAR_EDGE_WIDTH_M]: {
    content: 'solar_edge_width_m',
    label: 'lead.solarEdgeWidthM', // Breite der Solarseite des Daches (in m)
    validation: validateFloatNumberTwoDecimal1to100,
    keyboardType: 'numeric',
    testId: 'leadSolarEdgeWidthM',
  },
  [HOUSE_PROPERTIES.ROOF_TILE_TYPE]: {
    edit: 'rooftiletype_id',
    content: 'rooftiletype_name',
    isTextField: true,
    label: 'lead.roofTileType', // Dachziegelart
    keyboardType: 'default',
    testId: 'leadRoofTileType',
  },
  [HOUSE_PROPERTIES.ROOF_TILE_COVERAGE]: {
    content: 'roof_tile_coverage',
    label: 'lead.roofTileCoverage', // Ziegel-Deckmaß Länge x Breite (in mm)
    isDoubleField: true,
    keyboardType: 'default',
    testId: 'leadRoofTileCoverage',
  },
  [HOUSE_PROPERTIES.ROOF_TILE_DIMENSIONS]: {
    content: 'roof_tile_length_mm|roof_tile_width_mm',
    label: 'lead.roofTileCoverage', // Ziegel-Deckmaß Länge x Breite (in mm)
    isDoubleField: true,
    validation: [validateIntNumber0to2000, validateIntNumber0to2000],
    keyboardType: 'numeric',
    testId: 'leadRoofTileDimension',
  },
  [HOUSE_PROPERTIES.DESIRED_PV_OUTPUT]: {
    content: 'desired_pv_output_kwp',
    label: 'lead.desiredPVOutput', // Gewünschte Leistung der Anlage (in kWp)
    validation: validateFloatNumberTwoDecimal0to100k,
    keyboardType: 'numeric',
    testId: 'leadDesiredPVOutput',
  },
  [HOUSE_PROPERTIES.DESIRED_BS_CAPACITY]: {
    content: 'desired_bss_capacity_kwh',
    label: 'lead.desiredBSSCapacity', // Gewünschter Speicher / -größe (in kWh)
    isTextField: true,
    validation: validateTextMaxLength50,
    keyboardType: 'numbers-and-punctuation',
    testId: 'leadDesiredBSSCapacity',
  },
  [HOUSE_PROPERTIES.HOUSE_ELECTRICITY]: {
    content: 'house_electricity_consumption_kwh_per_year',
    label: 'lead.houseElectricity', // Licht Stromverbrauch pro Jahr (in kWh)
    validation: validateIntNumber0to300k,
    keyboardType: 'numeric',
    testId: 'leadHouseElectricity',
  },
  [HOUSE_PROPERTIES.PRICE_LIGHT]: {
    content: 'house_electricity_price_cents_per_kwh',
    label: 'lead.priceLight', // Licht Strompreis (Brutto) pro kWh (in Cent)
    validation: validateFloatNumberOneDecimal10to100,
    keyboardType: 'numeric',
    testId: 'leadPriceLight',
  },
  [HOUSE_PROPERTIES.BASIC_FEE_ELECTRICITY]: {
    content: 'house_electricity_basic_fee_euro_per_year',
    label: 'lead.basicFeeElectricity', // Licht Grundgebühr (Brutto) pro Jahr (in Euro)
    validation: validateFloatNumberTwoDecimal0to1000,
    keyboardType: 'numeric',
    testId: 'leadBasicFeeElectricity',
  },
  [HOUSE_PROPERTIES.HOUSE_ELECTRICITY_METER_NUMBER]: {
    content: 'house_electricity_meter_number',
    label: 'lead.houseElectricityMeterNumber', // Licht Stromzählernummer
    isTextField: true,
    validation: validateTextMaxLength50,
    keyboardType: 'default',
    testId: 'leadHouseElectricityMeterNumber',
  },
  [HOUSE_PROPERTIES.HEAT_ELECTRICITY]: {
    content: 'heat_electricity_consumption_kwh_per_year',
    label: 'lead.heatElectricity', // Wärme Stromverbrauch pro Jahr (in kWh)
    validation: validateIntNumber0to300k,
    keyboardType: 'numeric',
    testId: 'leadHeatElectricity',
  },
  [HOUSE_PROPERTIES.PRICE_HEAT]: {
    content: 'heat_electricity_price_cents_per_kwh',
    label: 'lead.priceHeat', // Wärme Strompreis (Brutto) pro kWh (in Cent)
    validation: validateFloatNumberOneDecimal10to100,
    keyboardType: 'numeric',
    testId: 'leadPriceHeat',
  },
  [HOUSE_PROPERTIES.BASIC_FEE_HEAT]: {
    content: 'heat_electricity_basic_fee_euro_per_year',
    label: 'lead.basicFeeHeat', // Wärme Grundgebühr (Brutto) pro Jahr (in Euro)
    validation: validateFloatNumberTwoDecimal0to1000,
    keyboardType: 'numeric',
    testId: 'leadBasicFeeHeat',
  },
  [HOUSE_PROPERTIES.HEAT_ELECTRICITY_METER_NUMBER]: {
    content: 'heat_electricity_meter_number',
    label: 'lead.heatElectricityMeterNumber', // Wärme Stromzählernummer
    isTextField: true,
    validation: validateTextMaxLength50,
    keyboardType: 'default',
    testId: 'leadHeatElectricityMeterNumber',
  },
  [HOUSE_PROPERTIES.LOADPROFILE]: {
    edit: 'loadprofile_id',
    content: 'loadprofile_name',
    isTextField: true,
    label: 'lead.loadProfile', // Lastprofil
    keyboardType: 'default',
    testId: 'leadLoadProfile',
  },
  // [HOUSE_PROPERTIES.SMART_HOME]: {
  //   content: 'smart_home',
  //   label: 'lead.smartHome', // Homematic
  //   isTextField: true,
  //   keyboardType: 'default',
  //   testId: 'leadSmartHome',
  //   radioOptions: [
  //     {
  //       value: SMART_HOME_VALUES.NOT_INTERESTED.value,
  //       label: SMART_HOME_VALUES.NOT_INTERESTED.label,
  //     },
  //     {
  //       value: SMART_HOME_VALUES.HEATER_ONLY.value,
  //       label: SMART_HOME_VALUES.HEATER_ONLY.label,
  //     },
  //     {
  //       value: SMART_HOME_VALUES.UNDERFLOOR_HEATING_ONLY.value,
  //       label: SMART_HOME_VALUES.UNDERFLOOR_HEATING_ONLY.label,
  //     },
  //     {
  //       value: SMART_HOME_VALUES.HEATER_AND_UNDERFLOOR_HEATING.value,
  //       label: SMART_HOME_VALUES.HEATER_AND_UNDERFLOOR_HEATING.label,
  //     },
  //   ],
  // },
} as const;

export const HOUSE_PROPERTIES_VIEW_REMOVED = [
  HOUSE_PROPERTIES.ROOF_TILE_DIMENSIONS,
  HOUSE_PROPERTIES.SMART_HOME,
];

export const HOUSE_PROPERTIES_EDIT_REMOVED = [
  HOUSE_PROPERTIES.ROOF_TILE_COVERAGE,
  HOUSE_PROPERTIES.SMART_HOME,
];

export const FORMNAME = {
  LEADS_FILTER: 'LEADS_FILTER',
  LEAD_CREATE: 'LEAD_CREATE',
  LEAD_SELECT: 'LEAD_SELECT',
  LEAD_DETAILS_EDIT: 'LEAD_DETAILS_EDIT',
  LEAD_DETAILS_TIMELINE: 'LEAD_DETAILS_TIMELINE',
  LEAD_DETAILS_FILES: 'LEAD_DETAILS_FILES',
  LEAD_DETAILS_FILE_EDIT: 'LEAD_DETAILS_FILE_EDIT',
  LEAD_DETAILS_IMAGE_EDIT: 'LEAD_DETAILS_IMAGE_EDIT',
  CALENDAR_ENTRY_DETAILS: 'CALENDAR_ENTRY_DETAILS',
  CALENDAR_ENTRY_CREATE: 'CALENDAR_ENTRY_CREATE',
  CALENDAR_ENTRY_EDIT: 'CALENDAR_ENTRY_EDIT',
  CALENDAR_ENTRY_DELETE: 'CALENDAR_ENTRY_DELETE',
  NOTE_CREATE: 'NOTE_CREATE',
  ADDRESS_SELECT: 'ADDRESS_SELECT',
  ACTIVITIES: 'ACTIVITIES',
  NOTE_DETAILS: 'NOTE_DETAILS',
  NOTE_DETAILS_EDIT: 'NOTE_DETAILS_EDIT',
  IMAGES_CREATE: 'IMAGES_CREATE',
  IMAGE_DELETE: 'IMAGE_DELETE',
  ADDRESS_DELETE: 'ADDRESS_DELETE',
  ADDRESS_VERIFY: 'ADDRESS_VERIFY',
  MISCFILE_CREATE: 'MISCFILE_CREATE',
  MISCFILE_DELETE: 'MISCFILE_DELETE',
  SATELLITE_IMAGE: 'SATELLITE_IMAGE',
  SALES_SELECT: 'SALES_SELECT',
  GLOBAL_SEARCH: 'GLOBAL_SEARCH',
  MEASUREMENT_PROTOCOL: 'MEASUREMENT_PROTOCOL',
  MEASUREMENT_PROTOCOL_META: 'MEASUREMENT_PROTOCOL_META',
  TASK_CREATE: 'TASK_CREATE',
  SIGNATURE_FORM: 'SIGNATURE_FORM',
  MASTER_DATA_SERVICE: 'MASTER_DATA_SERVICE_FORM',
  POWER_OF_ATTORNEY: 'POWER_OF_ATTORNEY',
  OFFER: 'OFFER',
  NOTIFICATION_TYPES: 'NOTIFICATION_TYPES',
  ERROR_REPORT: 'ERROR_REPORT',
} as const;

export const DRAWING_VALUES = {
  ROOF: 'ROOF',
  DOOR: 'DOOR',
  TRUCK: 'TRUCK',
  DANGER: 'DANGER',
  SCAFFOLD: 'SCAFFOLD',
  WALLBOX: 'WALLBOX',
} as const;

export const DRAWING_MARKERS_VALUES = {
  DOOR: 'DOOR',
  DANGER: 'DANGER',
  WALLBOX: 'WALLBOX',
  SCAFFOLD: 'SCAFFOLD',
} as const;

export const DRAWING_MODES = {
  MARKER: 'MARKER',
  LINE: 'LINE',
  POLYGON: 'POLYGON',
} as const;

export const SATELLITE_IMAGE_SELECT_OPTIONS = {
  SAVE_PHOTO: {
    label: 'satelliteImage.savePhoto',
    value: 'SAVE_PHOTO',
  },
  ADD_DRAWING: {
    label: 'satelliteImage.addDrawing',
    value: 'ADD_DRAWING',
  },
} as const;

export const SATELLITE_IMAGE_DRAWING_COLORS = {
  BLUE: '#00BAFF',
  GREEN: '#0CFF01',
  PURPLE: '#FF01FC',
  RED: '#EE1C25',
  ORANGE: '#FF7E00',
  YELLOW: '#FFFC00',
  WHITE: '#FFFFFF',
} as const;

export const SATELLITE_IMAGE_BACKGROUND_COLOR = '#2C2C2C';

export const FORM_CHANGE_PERSIST_TYPE = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
} as const;

export const PHONE_NUMBER_TYPE = {
  PRIVATE: {
    label: 'labelListItem.private',
    value: 'PRIVATE',
  },
  BUSINESS: {
    label: 'labelListItem.work',
    value: 'BUSINESS',
  },
} as const;

export const EMAIL_ADDRESS_TYPE = {
  PRIVATE: {
    label: 'labelListItem.private',
    value: 'PRIVATE',
  },
  BUSINESS: {
    label: 'labelListItem.work',
    value: 'BUSINESS',
  },
} as const;

export const PLATFORM_FILE_TYPE = {
  [OS.ANDROID]: 'mp3',
  [OS.IOS]: 'm4a',
} as const;

export const ENCODING = {
  BASE64: 'base64',
} as const;

export const DB_ENTITY_CHANGE_TYPE = {
  DELETE: 'delete',
  CREATE: 'create',
  UPDATE: 'update',
  NONE: 'none',
  DELETE_UNPUSHED: 'delete_unpushed',
} as const;

export const LEAD_SORT = {
  SURNAME: 'contactSurname',
  SURNAME_DSC: 'contactSurnameDsc',
  CREATED_AT: 'createdAt',
  CREATED_AT_DSC: 'createdAtDsc',
} as const;

export const API_SORT_LEAD = {
  ID: 'id',
  CREATED_AT: 'created_at',
  PRENAME: 'contact.prename',
  SURNAME: 'contact.surname',
} as const;

export const API_SORT_ORDER = {
  ASC: 'asc',
  DESC: 'dsc',
} as const;

export const TABLE_TYPE = {
  BACKEND: 'backend',
  CHANGE: 'change',
  VIEW: 'view',
} as const;

export const VALIDATION_MESSAGE = {
  DATE_END_BEFORE_START: 'validation.endDateBeforeStartDate',
} as const;

export const USER_ROLE = {
  SALES: 'SALES',
} as const;

export const MIME_TYPE = {
  APPLICATION_EPUB_ZIP: 'application/epub+zip',
  APPLICATION_PDF: 'application/pdf',
  APPLICATION_MS_WORD: 'application/msword',
  APPLICATION_VND_MS_EXCEL: 'application/vnd.ms-excel',
  APPLICATION_VND_MS_POWERPOINT: 'application/vnd.ms-powerpoint',
  APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_PRESENTATION:
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_SHEET:
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_DOCUMENT:
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  APPLICATION_XML: 'application/xml',
  APPLICATION_ZIP: 'application/zip',
  AUDIO_M4A: 'audio/m4a',
  AUDIO_MPEG: 'audio/mpeg',
  AUDIO_OPUS: 'audio/opus',
  AUDIO_WAV: 'audio/wav',
  IMAGE_BMP: 'image/bmp',
  IMAGE_GIF: 'image/gif',
  IMAGE_HEIC: 'image/heic',
  IMAGE_HEIF: 'image/heif',
  IMAGE_JPEG: 'image/jpeg',
  IMAGE_JPG: 'image/jpg',
  IMAGE_PNG: 'image/png',
  IMAGE_SVG_XML: 'image/svg+xml',
  TEXT_CSV: 'text/csv',
  TEXT_PLAIN: 'text/plain',
  TEXT_XML: 'text/xml',
  VIDEO_MP4: 'video/mp4',
  VIDEO_MPEG: 'video/mpeg',
  VIDEO_MOV: 'video/quicktime',
} as const;

export const TIME_FILTER_VALUE = {
  ALL: 'ALL',
  TODAY: 'TODAY',
} as const;

// The order inside is important
export const MEASUREMENT_PROTOCOL_STEPS = {
  MARKET_DATA_REGISTER: 'MARKET_DATA_REGISTER',
  PROPERTY: 'PROPERTY',
  ROOF: 'ROOF',
  ROOF_STRUCTURES: 'ROOF_STRUCTURES',
  SCAFFOLD: 'SCAFFOLD',
  SCAFFOLD_EXPERT: 'SCAFFOLD_EXPERT',
  ENERGY_STORAGE_AND_METER: 'ENERGY_STORAGE_AND_METER',
  CONNECTIONS: 'CONNECTIONS',
  CURRENT_CHECKLIST: 'CURRENT_CHECKLIST',
  CONCLUSION: 'CONCLUSION',
} as const;

export const MEASUREMENT_PROTOCOL_STEP_SUBSECTIONS = {
  MARKET_DATA_REGISTER_COMMENT: 'MARKET_DATA_REGISTER_COMMENT',
  MARKET_DATA_REGISTER: 'MARKET_DATA_REGISTER',
  NETWORK_CONNECTIVITY: 'NETWORK_CONNECTIVITY',
  PERFORMANCE_AND_STORAGE: 'PERFORMANCE_AND_STORAGE',
  MAIN_METER: 'MAIN_METER',
  EXISTING_GENERATING_PLANT: 'EXISTING_GENERATING_PLANT',
  METER_INITIAL: 'METER_INITIAL',
  METER_END: 'METER_END',
  LARGE_CONSUMER: 'LARGE_CONSUMER',
  LIGHT: 'LIGHT',
  WARMTH: 'WARMTH',
  LOAD_PROFILE: 'LOAD_PROFILE',
  CONSUMPTION_COMMENT: 'CONSUMPTION_COMMENT',
  NEIGHBORING_PROPERTY: 'NEIGHBORING_PROPERTY',
  AERIAL_PHOTO_OR_SKETCH: 'AERIAL_PHOTO_OR_SKETCH',
  MONUMENT_PROTECTION: 'MONUMENT_PROTECTION',
  PLANT_DELIVERY: 'PLANT_DELIVERY',
  STORAGE_FACILITY_AT_GROUND_LEVEL: 'STORAGE_FACILITY_AT_GROUND_LEVEL',
  PROPERTY_COMMENT: 'PROPERTY_COMMENT',
  INITIAL_DATA: 'INITIAL_DATA',
  ROOF_COVERING: 'ROOF_COVERING',
  ROOF_TYPE: 'ROOF_TYPE',
  ROOF_TILE: 'ROOF_TILE',
  DC_CABLE_ROUTING: 'DC_CABLE_ROUTING',
  ROOF_SCAFFOLD: 'ROOF_SCAFFOLD',
  ROOF_STRUCTURES: 'ROOF_STRUCTURES',
  ROOF_MATERIAL: 'ROOF_MATERIAL',
  FLASH_UNIT: 'FLASH_UNIT',
  SOLAR_THERMAL: 'SOLAR_THERMAL',
  OTHER_ROOF_STRUCTURES: 'OTHER_ROOF_STRUCTURES',
  ROOF_TRUSS: 'ROOF_TRUSS',
  ROOF_AREA: 'ROOF_AREA',
  ROOF_COMMENT: 'ROOF_COMMENT',
  ROOF_RENOVATION: 'ROOF_RENOVATION',
  OBSTACLES: 'OBSTACLES',
  OBSTACLES_COMMENT: 'OBSTACLES_COMMENT',
  STORAGE_AND_METER_CABINET: 'STORAGE_AND_METER_CABINET',
  POST_METER_SECTION: 'POST_METER_SECTION',
  STORAGE_LOCATION: 'STORAGE_LOCATION',
  METER_CABINET: 'METER_CABINET',
  GROUNDING: 'GROUNDING',
  BACKUP_POWER_PACKAGE: 'BACKUP_POWER_PACKAGE',
  YEARLY_CONSUMPTION: 'YEARLY_CONSUMPTION',
  METER_CONCEPT: 'METER_CONCEPT',
  STORAGE_AND_METER_COMMENT: 'STORAGE_AND_METER_COMMENT',
  HOUSE_CONNECTION_BOX_LOCATION: 'HOUSE_CONNECTION_BOX_LOCATION',
  POWER_CONNECTION_TYPE: 'POWER_CONNECTION_TYPE',
  LINE_TYPE: 'LINE_TYPE',
  CONNECTIONS_END: 'CONNECTIONS_END',
  HAK: 'HAK',
  ZAS_AND_HAS: 'ZAS_AND_HAS',
  CONNECTIONS_COMMENT: 'CONNECTIONS_COMMENT',
  CURRENT_CHECKLIST: 'CURRENT_CHECKLIST',
  INTERNET_CONNECTION: 'INTERNET_CONNECTION',
  WALLBOX: 'WALLBOX',
  OTHER_EXISTING_SYSTEMS: 'OTHER_EXISTING_SYSTEMS',
  EXISTING_PHOTOVOLTAIC_SYSTEM: 'EXISTING_PHOTOVOLTAIC_SYSTEM',
  EXISTING_HEAT_PUMP: 'EXISTING_HEAT_PUMP',
  CURRENT_CHECKLIST_COMMENT: 'CURRENT_CHECKLIST_COMMENT',
  SCAFFOLD_OBSTACLES: 'SCAFFOLD_OBSTACLES',
  SCAFFOLD_POSITION: 'SCAFFOLD_POSITION',
  SCAFFOLD_COMMENT: 'SCAFFOLD_COMMENT',
  SCAFFOLD_GENERAL: 'SCAFFOLD_GENERAL',
  ROOF_STRUCTURES_COMMENT: 'ROOF_STRUCTURES_COMMENT',
  SCAFFOLD_EXPERT: 'SCAFFOLD_EXPERT',
  CONCLUSION: 'CONCLUSION',
  CONCLUSION_COMMENT: 'CONCLUSION_COMMENT',
} as const;

export const COMPRESSION_ERROR_KEY = {
  NOOP: 'NOOP',
  COMPRESSION_FAILURE: 'COMPRESSION_FAILURE',
  LOCKED_BY_OTHER_COMPRESSION: 'LOCKED_BY_OTHER_COMPRESSION',
  FILE_HANDLING: 'FILE_HANDLING',
} as const;

export const MEASUREMENT_PROTOCOL_DIALOGS_CONTENT = {
  INITIAL: 'INITIAL',
  OFFER_CHECKLIST: 'OFFER_CHECKLIST',
  ADD_EDIT_ITEMS: 'ADD_EDIT_ITEMS',
  CONSUMPTION: {
    PHOTOGRAPHY: 'PHOTOGRAPHY',
  },
  PROPERTY: {
    AERIAL_VIEW: 'AERIAL_VIEW',
  },
  ROOF: {
    MAIN_BUILDING: 'MAIN_BUILDING',
    BRICK_MEASURE: 'BRICK_MEASURE',
    EXECUTION_SUBSTRUCTURE: 'EXECUTION_SUBSTRUCTURE',
    ROOF_STRUCTURES: 'ROOF_STRUCTURES',
    ROOF_CONSTRUCTION: 'ROOF_CONSTRUCTION',
    ROOF_CONSTRUCTIONB: 'ROOF_CONSTRUCTIONB',
    ROOF_CONSTRUCTIONC: 'ROOF_CONSTRUCTIONC',
  },
  OBSTACLE: 'OBSTACLE',
  CONNECTIONS: {
    HAK_PHOTODOCUMENTATION: 'HAK_PHOTODOCUMENTATION',
  },
  SCAFFOLD: {
    SCAFFOLD_OBSTACLE: 'SCAFFOLD_OBSTACLE',
    PUBLIC_WALKWAY: 'PUBLIC_WALKWAY',
  },
  ENERGY_STORAGE_AND_METER: {
    SPACE_REQUIREMENTS: 'SPACE_REQUIREMENTS',
    EQUIPOTENTIAL_BONDING_BAR: 'EQUIPOTENTIAL_BONDING_BAR',
  },
} as const;

export const ITEM_TO_DELETE = {
  ADDRESS: 'address',
  CALENDAR_ENTRY: 'calendarEntry',
  EMAIL: 'email',
  FILE: 'file',
  PHONE_NUMBER: 'phoneNumber',
} as const;

export const DEEP_LINK_TYPE = {
  INVALID: 'invalid',
  UNKNOWN: 'unknown',
  VIEW_ENTITY: 'viewEntity',
} as const;

export const UNITS = {
  kWp: 'kWp',
  kWh: 'kWh',
  euro: '€',
  cent: 'cent',
  piece: (translate: (key: string) => string) =>
    translate('measurementProtocolSteps.energyStorageAndMeter.piece'),
  kW: 'kW',
  m: 'm',
  cm: 'cm',
  mm: 'mm',
  degrees: '°',
} as const;

// ids of lead sources with visual indicators
export const OWN_LEAD_SOURCE_ID = 33;
export const FAIR_LEAD_SOURCE_ID = 99;
export const CONTACT_PAGE_SOURCE_ID = 44;

export const LEAD_SOURCE_TO_LABEL_MAP = {
  [OWN_LEAD_SOURCE_ID]: 'lead.source.ownLead',
  [FAIR_LEAD_SOURCE_ID]: 'lead.source.fairLead',
  [CONTACT_PAGE_SOURCE_ID]: 'lead.source.contactPage',
} as const;

export const TRANSLATION_LOCALE_CODES = {
  DE: 'DE',
} as const;

export const MEASUREMENT_PROTOCOL_ENTITY_TO_NUMBER_PROPERTIES_MAP = {
  [ENTITY.MEASUREMENT_PROTOCOL]: MEASUREMENT_PROTOCOL_NUMBER_PROPERTIES,
  [ENTITY.MEASUREMENT_PROTOCOL_ROOF]:
    MEASUREMENT_PROTOCOL_ROOF_NUMBER_PROPERTIES,
  [ENTITY.MEASUREMENT_PROTOCOL_METER]:
    MEASUREMENT_PROTOCOL_METER_NUMBER_PROPERTIES,
} as const;

export const HTTP_METHOD = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
} as const;

export const PDF_TYPE = {
  INITIAL: 'INITIAL',
  CURRENT: 'CURRENT',
  FULL: 'FULL',
  CHECKLIST: 'CHECKLIST',
} as const;

export const PDF_NAME_BY_TYPE = {
  [PDF_TYPE.INITIAL]: 'Erstanalyse',
  [PDF_TYPE.CURRENT]: 'Zwischenstand',
  [PDF_TYPE.FULL]: 'Beratungsprotokoll',
  [PDF_TYPE.CHECKLIST]: 'Checkliste',
} as const;

export const RADIO_BINARY_OPTIONS = translate => [
  {
    value: true,
    shortBoldedLabel: translate(
      'measurementProtocolSteps.connections.radioYes',
    ),
  },
  {
    value: false,
    shortBoldedLabel: translate('measurementProtocolSteps.connections.radioNo'),
  },
];

export const REVIEW_PLATFORM = {
  GOOGLE: 'Google',
  TRUSTPILOT: 'Trustpilot',
} as const;

export const REVIEW_PLATFORM_LINK = {
  Google: 'https://g.page/r/CbFPYYyo1KixEBM/review',
  Trustpilot: 'https://de.trustpilot.com/review/ekd-solar.de',
} as const;

export const COMMUNICATION_CHANNEL = {
  WHATSAPP: 'WhatsApp',
  EMAIL: 'Email',
} as const;

export const PROJECT_TYPES_SELECT_ITEMS = [
  { label: 'PV + Speicher', value: '1' },
  { label: 'Speichernachrüstung', value: '2' },
  { label: 'PV-Erweiterung', value: '3' },
  { label: 'Speichererweiterung', value: '4' },
  { label: 'Wallbox', value: '5' },
  { label: 'PV + Speicher + Wallbox', value: '6' },
];

export const OFFER_PROJECT_TYPE = {
  PV_AND_STORAGE: 1,
  WALLBOX: 3,
};

export const OFFER_PRODUCT_LINE = {
  PREMIUM: 5,
  M_TEC_BIG: 4,
  ASPE2_ACTION: 6,
  E2_ACTION_PACKAGE: 7,
};

export const OFFER_FIELD_TYPE = {
  OPTIONS: 'OPTIONS',
  NUMBER: 'NUMBER',
  BOOLEAN: 'BOOLEAN',
  NESTED: 'NESTED',
  INFO: 'INFO',
  BOX: 'BOX',
  SPECIFIC: { MODULE_TOTAL_POWER: 'MODULE_TOTAL_POWER' },
};

export const OPTIONAL_DEFAULT_VALUES = {
  NORMAL: 'normal',
  REMOVE: 'remove',
  ALTERNATIVE: 'alternative',
  NO_CHOICE: 'noChoice',
};

export const IN_PLANNING_LEAD_PHASE_ID = 34;

// this is a mapping with each mp entity and the visual documentation field name for category
export const VISUAL_DOCUMENTATION_FIELD_NAME_MAPPING = {
  [ENTITY.MEASUREMENT_PROTOCOL]: {
    [DOCUMENT_DEFINITION.MEASUREMENT_PROTOCOL_STORAGE_FACILITY]:
      'storageFacilityVisualDocumentation',
    [DOCUMENT_DEFINITION.MEASUREMENT_PROTOCOL_SCAFFOLD_PUBLIC_OBSTACLE]:
      'scaffoldPublicObstacleVisualDocumentation',
    [DOCUMENT_DEFINITION.MEASUREMENT_PROTOCOL_EQUIPOTENTIAL_BONDING_RAIL]:
      'equipotentialBondingRailVisualDocumentation',
    [DOCUMENT_DEFINITION.MEASUREMENT_PROTOCOL_OVERHEAD_LINE]:
      'overheadLineVisualDocumentation',
    [DOCUMENT_DEFINITION.MEASUREMENT_PROTOCOL_HEAT_PUMP]:
      'heatPumpVisualDocumentation',
    [DOCUMENT_DEFINITION.LOCATION_WALLBOX]:
      'locationWallboxVisualDocumentation',
    [DOCUMENT_DEFINITION.MEASUREMENT_PROTOCOL_STORAGE_LOCATION]:
      'storageLocationVisualDocumentation',
    [DOCUMENT_DEFINITION.MEASUREMENT_PROTOCOL_ENERGY_METER_CABINET]:
      'energyMeterCabinetVisualDocumentation',
    [DOCUMENT_DEFINITION.MEASUREMENT_PROTOCOL_GROUNDING]:
      'groundingVisualDocumentation',
    [DOCUMENT_DEFINITION.MEASUREMENT_PROTOCOL_MONUMENT_PROTECTION]:
      'propertyUnderMonumentalProtectionVisualDocumentation',
    [DOCUMENT_DEFINITION.MEASUREMENT_PROTOCOL_STORAGE_METER_CABLE_ROUTE]:
      'storageMeterVisualDocumentation',
    [DOCUMENT_DEFINITION.MEASUREMENT_PROTOCOL_POWER_CONNECTION_TYPE]:
      'powerConnectionTypeVisualDocumentation',
    [DOCUMENT_DEFINITION.MEASUREMENT_PROTOCOL_NETWORK_CONNECTIVITY]:
      'networkConnectivityVisualDocumentation',
    [DOCUMENT_DEFINITION.MEASUREMENT_PROTOCOL_ANNOTATED_CUSTOM_IMAGE]:
      'annotatedSatelliteImage',
  },
  [ENTITY.MEASUREMENT_PROTOCOL_ROOF]: {
    [DOCUMENT_DEFINITION.MEASUREMENT_PROTOCOL_ROOF_AREA]:
      'roofAreaVisualDocumentation',
    [DOCUMENT_DEFINITION.MEASUREMENT_PROTOCOL_BRICK]:
      'roofTileVisualDocumentation',
    [DOCUMENT_DEFINITION.MEASUREMENT_PROTOCOL_DC_CABLE_ROUTING]:
      'dcCableRoutingVisualDocumentation',
    [DOCUMENT_DEFINITION.MEASUREMENT_PROTOCOL_SCAFFOLD_INSTALLATION_AREA]:
      'scaffoldInstallationAreaVisualDocumentation',
    [DOCUMENT_DEFINITION.MEASUREMENT_PROTOCOL_ROOF_RENOVATION]:
      'renovationPlannedVisualDocumentation',
    [DOCUMENT_DEFINITION.MEASUREMENT_PROTOCOL_ROOF_TRUSS_OTHERS]:
      'roofTrussOthersVisualDocumentation',
    [DOCUMENT_DEFINITION.MEASUREMENT_PROTOCOL_ROOF_TRUSS]:
      'roofTrussVisualDocumentation',
  },
  [ENTITY.MEASUREMENT_PROTOCOL_METER]: {
    [DOCUMENT_DEFINITION.MEASUREMENT_PROTOCOL_ENERGY_STORAGE_METER]:
      'meterVisualDocumentation',
    [DOCUMENT_DEFINITION.MEASUREMENT_PROTOCOL_LARGE_CONSUMER]:
      'largeConsumerVisualDocumentation',
    [DOCUMENT_DEFINITION.MEASUREMENT_PROTOCOL_EXISTING_GENERATING_PLANT]:
      'existingGeneratingPlantVisualDocumentation',
  },
};
